var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('rect',{attrs:{"fill":"black","x":_vm.containerX,"y":_vm.containerY,"width":_vm.containerWidth,"height":_vm.containerHeight}}),_vm._v(" "),_c('text',{ref:"textEl",attrs:{"x":_vm.x,"y":_vm.y,"font-size":"10","font-weight":"bold","fill":"red"}},[_vm._v("\n    PAUL\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c37738c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/slide-elements/InspectingUserLabel.vue
// module id = 232
// module chunks = 0 1